import { useSavedPosts } from '../../hooks/usePosts';
import PostCard from './PostCard';

export default function SavedPostsSection() {
  const { data: posts, isLoading, error } = useSavedPosts();

  if (isLoading) {
    return (
      <div className="space-y-4">
        <div className="theme-bg-primary rounded-lg shadow-sm border theme-border-primary p-6">
          <h2 className="text-xl font-semibold theme-text-primary mb-4">Saved Posts</h2>
          <div className="text-center py-8">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-healthy-green mx-auto"></div>
            <p className="mt-2 theme-text-secondary">Loading saved posts...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="space-y-4">
        <div className="theme-bg-primary rounded-lg shadow-sm border theme-border-primary p-6">
          <h2 className="text-xl font-semibold theme-text-primary mb-4">Saved Posts</h2>
          <div className="text-center py-8">
            <div className="text-red-500 mb-2">
              <svg className="h-8 w-8 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <p className="theme-text-secondary mb-4">Failed to load saved posts</p>
            <p className="text-sm theme-text-tertiary">{error.message}</p>
          </div>
        </div>
      </div>
    );
  }

  if (!posts || posts.length === 0) {
    return (
      <div className="space-y-4">
        <div className="theme-bg-primary rounded-lg shadow-sm border theme-border-primary p-6">
          <h2 className="text-xl font-semibold theme-text-primary mb-4">Saved Posts</h2>
          <div className="text-center py-8">
            <div className="w-12 h-12 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-6 h-6 text-healthy-green" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z" />
              </svg>
            </div>
            <p className="theme-text-secondary mb-2">No saved posts yet</p>
            <p className="text-sm theme-text-tertiary">Posts you save will appear here for easy access</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="theme-bg-primary rounded-lg shadow-sm border theme-border-primary p-4">
        <h2 className="text-xl font-semibold theme-text-primary">Saved Posts ({posts.length})</h2>
      </div>
      {posts.map((post) => (
        <PostCard key={post.id} post={post} />
      ))}
    </div>
  );
}